export interface CustomFieldsEmptyStateOverrides {
  title?: string;
  subtitle?: string;
}
